import { Form, Input, Button } from "antd";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import { encrypt_cookie } from "../data/allfunction";
import "./Login.css";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../app/features/user/userSlice";

const ip = process.env.REACT_APP_IP;
const l = process.env.REACT_APP_LINK;
async function getIp() {
  return fetch("https://api.db-ip.com/v2/free/self")
    .then((response) => response.text())
    .then((data) => data);
}

function Login() {
  const [loading, setloading] = useState(false);
  const [getUseIp, setgetUseIp] = useState("");
  const dispatch = useDispatch();
  let history = useHistory();

  function saveLogin(item) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify(item);

    // var requestOptions = {
    //     method: 'POST',
    //     headers: myHeaders,
    //     body: raw,
    //     redirect: 'follow'
    // };

    // fetch(`${ip}sell_online/saveLogin`, requestOptions)
    //     .then(response => response.text())
    //     .then(result => console.log(result))
    //     .catch(error => console.log('error', error));
  }
  async function get_log_in(value) {
    const { username, password } = value;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      user: username,
      pass: password,
      from: "sellonline",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    // alert(`${ip}users/login`)
    return fetch(`${ip}users/login`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        return result;
      })
      .catch((error) => error);
  }
  const onFinish = async (values) => {
    try {
      setloading(true);
      let { data } = await get_log_in(values);
      // console.log(data);
      if (data.status === 401) {
        alert(data.msg);
        saveLogin({
          user: JSON.stringify(values),
          detail: getUseIp,
          status: "0",
        });
      } else {
        saveLogin({
          user: JSON.stringify(values.username),
          detail: getUseIp,
          status: "1",
        });
        data = { ...data, ...{ log: true } };
        //    console.log(data);
        dispatch(setUser(data));
        Cookies.set("log", encrypt_cookie(JSON.stringify(data)), {
          expires: 1 / 12,
        });
        history.push(l);
      }

      setTimeout(() => {
        setloading(false);
      }, 1000);
    } catch (error) {
      // alert(error)
      setloading(false);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 19 },
    },
  };

  useEffect(() => {
    async function ip() {
      try {
        setgetUseIp(await getIp());
      } catch (error) {}
    }
    ip();
  }, []);
  return (
    <div className="modal">
      <div className="modal-content">
        <div className="container">
          <div className="centerDiv">
            {/* <img src={"./images/full.png"} width={"50%"} alt="ZJI logo" /> */}

            <img
              src={"https://www.zhongjiinsurance.com/images/logo.png"}
              width={"60%"}
              alt="ZJI logo"
            />
          </div>
          <h1 className="text-center">
            ຍິນດີຕ້ອນຮັບເຂົ້າສູ່ລະບົບການຂາຍປະກັນໄພ
          </h1>
          <Form
            {...formItemLayout}
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="ຜູ້ເຂົ້າໃຊ້ງານລະບົບ"
              name="username"
              rules={[{ required: true, message: "ກະລຸນາເພີ່ມຜູ້ໃຊ້ງານ!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="ລະຫັດຜ່ານ"
              name="password"
              rules={[{ required: true, message: "ກະລຸນາເພີ່ມລະຫັດຜ່ານ!" }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                ເຂົ້າສູ່ລະບົບ
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Login;
